/**
 * Generated runtime TestId mirror for frontend/src/pages/Roles.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RolesTestIds = {
  colDescription: "col-description",
  colKey: "col-key",
  colName: "col-name",
  colType: "col-type",
  createRoleButton: "create-role-button",
  createRoleDialogTitle: "create-role-dialog-title",
  roleDescriptionInput: "role-description-input",
  roleKeyError: "role-key-error",
  roleKeyInput: "role-key-input",
  roleNameInput: "role-name-input",
  rolesList: "roles-list",
  linkRoleDetail: (role_id: string) => `link-role-detail-${role_id}`,
  linkRoleDetailPrefix: () => "link-role-detail-" as TestIdPrefix,
  roleDescription: (role_id: string) => `role-description-${role_id}`,
  roleDescriptionPrefix: () => "role-description-" as TestIdPrefix,
  roleKey: (role_id: string) => `role-key-${role_id}`,
  roleKeyPrefix: () => "role-key-" as TestIdPrefix,
  roleRow: (role_id: string) => `role-row-${role_id}`,
  roleRowPrefix: () => "role-row-" as TestIdPrefix,
  roleTypeBadge: (role_id: string) => `role-type-badge-${role_id}`,
  roleTypeBadgePrefix: () => "role-type-badge-" as TestIdPrefix
} as const;
